<!-- TODO: Restructurar maquetado y estilos para los diferentes tipos de botones con este componente -->
<button
  class="text-am-white"
  [style.width]="width"
  [style.height]="height"
  [style.font-size]="fontSize"
  [style.font-weight]="fontWeight"
  (click)="onClick()"
  [disabled]="disabled"
  [ngClass]="{
    'fs-20px': theme !== 'iropsRebrandingWhite',
    'bg-red border-0 rounded-pill': theme === 'primary',
    'bg-am-medium-blue border-am rounded-pill': theme === 'dark',
    'bg-transparent border-am rounded-pill': theme === 'transparent',
    'bg-am-irops-banner-rebranding border-0 border-radius-0': theme === 'iropsRebrandingBlue',
    'bg-am-irops-pink border-0 BannerIropsFlightInfo-button': theme === 'iropsRebrandingPink',
    'bg-am-irops-white text-am-blue-rebrand fs-18px fw-medium-x': theme === 'iropsRebrandingWhite'
  }"
>{{ text | translate }}
<ng-content select="[icon]"></ng-content>
</button>
